import { useState, createContext, useContext } from "react";

const NERContext = createContext();
export const useNER = () => useContext(NERContext);

// const NER_KEY = "ner_state_jusrist_dz";

const NERProvider = ({ children }) => {
  const [nerState, setNerState] = useState(() => {
    // const hist = localStorage.getItem(NER_KEY);
    // if (hist) return JSON.parse(hist);
    return {
      person: false,
      date: false,
      location: false,
      organisation: false,
      citation: false,
    };
  });

  const updateNerState = (entity, checked) => {
    setNerState((prev) => {
      const new_state = { ...prev, [entity]: checked };
      // localStorage.setItem(NER_KEY, JSON.stringify(new_state));
      return new_state;
    });
  };
  return (
    <NERContext.Provider value={{ nerState, updateNerState }}>
      {children}
    </NERContext.Provider>
  );
};

export default NERProvider;
